export default __webpack_public_path__ + "static/media/russia.f0821fbd.png";